import React from 'react';

interface WordMatrixProps {
  data: Array<{
    text: string;
    sentiment: number;
    emotions: { [k: string]: number };
    value: number;
  }>;
}

const emotionList = ['Happy', 'Angry', 'Surprise', 'Sad', 'Fear'];

const getSentimentLabel = (score: number) => {
  if (score > 0.2) return 'Positive';
  if (score < -0.2) return 'Negative';
  return 'Neutral';
};

const getSentimentColor = (score: number) => {
  if (score > 0.2) return '#2ecc71';
  if (score < -0.2) return '#e74c3c';
  return '#f1c40f';
};

const WordMatrix: React.FC<WordMatrixProps> = ({ data }) => {
  return (
    <div style={{ margin: '2rem 0', textAlign: 'center' }}>
      <h2 style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: 22, color: '#34495e' }}>
        Theme × Sentiment/Emotion Matrix
      </h2>
      <div style={{ overflowX: 'auto', margin: '0 auto', maxWidth: 900 }}>
        <table style={{ borderCollapse: 'collapse', width: '100%', fontFamily: 'Montserrat, sans-serif', fontSize: 15 }}>
          <thead>
            <tr>
              <th style={{ padding: 8, borderBottom: '2px solid #ccc', background: '#f8f9fa' }}>Theme</th>
              <th style={{ padding: 8, borderBottom: '2px solid #ccc', background: '#f8f9fa' }}>Mentions</th>
              <th style={{ padding: 8, borderBottom: '2px solid #ccc', background: '#f8f9fa' }}>Sentiment</th>
              {emotionList.map(e => (
                <th key={e} style={{ padding: 8, borderBottom: '2px solid #ccc', background: '#f8f9fa' }}>{e}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map(row => (
              <tr key={row.text}>
                <td style={{ padding: 8, borderBottom: '1px solid #eee', fontWeight: 600 }}>{row.text}</td>
                <td style={{ padding: 8, borderBottom: '1px solid #eee', textAlign: 'center' }}>{row.value}</td>
                <td style={{ padding: 8, borderBottom: '1px solid #eee', textAlign: 'center', color: getSentimentColor(row.sentiment), fontWeight: 600 }}>
                  {getSentimentLabel(row.sentiment)}
                </td>
                {emotionList.map(e => (
                  <td key={e} style={{ padding: 8, borderBottom: '1px solid #eee', textAlign: 'center' }}>
                    {row.emotions[e] !== undefined ? (row.emotions[e] * 100).toFixed(0) + '%' : '-'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ fontSize: 13, color: '#888', marginTop: 8 }}>
        Sentiment: green=positive, red=negative, yellow=neutral. Emotions: % of responses mentioning theme.
      </div>
    </div>
  );
};

export default WordMatrix;
